
// these ids are supposed to be recognized on backend
export enum UserCondition {
    CURRENT_USER = 'current-user',
    NOT_ASSIGNED = 'not-assigned',
}